import { Card, Col, notification, Row, Spin, Tag, Typography } from "antd";
import { ContainerComponent } from "../../../components";
import { useQuery } from "../../../hooks";
import { Link } from "react-router-dom";
import "../css/devboost.css";

const { Meta } = Card;

export const DevBoostView = () => {
    const [, contextHolder] = notification.useNotification()
    const { data: devboosts, loading } = useQuery({
        url: "/devboost",
        options: { method: "GET" },
    });

    return (
        <>
            {contextHolder}
            <ContainerComponent
                style={{
                    marginBottom: 8
                }}
            >
                <Row>
                    <Col span={24}>
                        <Typography.Title style={{ textAlign: "left" }} level={2}>
                            Catálogo de Casos de Éxito
                        </Typography.Title>
                    </Col>
                </Row>
            </ContainerComponent>
            {loading ? (
                <Spin size="large" justify="center" />
            ) : (
                <Row gutter={[16, 16]} style={{ display: "flex", alignItems: "stretch" }}>
                    {devboosts?.map((devboost) => (
                        <Col span={24} md={12} lg={8} key={devboost.id}>
                            <Link
                                to={`/dev-boost/${devboost.id}`}
                            >
                                <Card
                                    cover={
                                        devboost.successStoryImg && (
                                            <img
                                                alt={devboost.title}
                                                src={devboost.successStoryImg}
                                                style={{
                                                    width: "100%",
                                                    height: "200px",
                                                    objectFit: "cover",
                                                    borderTopLeftRadius: 20,
                                                    borderTopRightRadius: 20,
                                                    display: "block"
                                                }}
                                            />
                                        )
                                    }
                                    hoverable
                                    style={{
                                        height: '100%',
                                        display: "flex",
                                        flexDirection: "column",
                                        borderRadius: 20,
                                        padding: 0
                                    }}
                                    styles={{
                                        body: {
                                            display: "flex",
                                            flexDirection: "column",
                                            height: "100%",
                                            padding: "0 24px"
                                        }
                                    }}
                                >
                                    <Meta
                                        title={
                                            <Typography.Title
                                                level={5}
                                                className="card-title"
                                            >
                                                {devboost.title}
                                            </Typography.Title>}
                                    />
                                    <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                        {/* Industry */}
                                        <div style={{ textAlign: "center", marginBottom: 16 }}>
                                            <Typography.Title level={4}
                                                style={{
                                                    fontWeight: 700,
                                                    color: "#a7a9aaff",
                                                    margin: 0,
                                                    fontSize: "1.00rem"
                                                }}
                                            >
                                                Industria: {devboost.industry}
                                            </Typography.Title>
                                        </div>
                                        {/* Problem Description */}
                                        <div style={{ textAlign: "justify", marginBottom: 8 }}>
                                            <Typography.Text level={4} style={{ color: "#696969" }}>
                                                {devboost.problemDescription
                                                    ? devboost.problemDescription
                                                    : ""}
                                            </Typography.Text>
                                        </div>
                                        {/* Technologies */}
                                        <div style={{ textAlign: "left", marginBottom: 8 }}>
                                            <Typography.Text>
                                                Tecnologías:&nbsp;
                                                {devboost.technologies.map((tech, idx) => (
                                                    <Tag
                                                        color="blue"
                                                        key={tech.id}
                                                        style={{
                                                            marginRight: 6,
                                                            background: "#e6fffb",
                                                            color: "#13c2c2",
                                                            border: "1px solid #13c2c2"
                                                        }}
                                                    >
                                                        {tech.name}
                                                    </Tag>
                                                ))}
                                            </Typography.Text>
                                        </div>
                                        {/* Benefits */}
                                        <div style={{ textAlign: "left", marginBottom: 8 }}>
                                            <Typography.Text>
                                                Beneficios:&nbsp;
                                                {devboost.benefits.map((benefit, idx) => (
                                                    <Tag
                                                        color="green"
                                                        key={benefit + idx}
                                                        style={{
                                                            marginRight: 6,
                                                            background: "#fff7e6",
                                                            color: "#fa8c16",
                                                            border: "1px solid #fa8c16",
                                                            whiteSpace: "normal",
                                                            wordBreak: "break-word",
                                                        }}
                                                    >
                                                        {benefit}
                                                    </Tag>
                                                ))}
                                            </Typography.Text>
                                        </div>
                                        {/* Score */}
                                        {/* <div style={{ textAlign: "center", marginTop: 16 }}>
                                            <Rate value={devboost.score} disabled />
                                        </div> */}
                                    </div>
                                    <div style={{ textAlign: "right", marginTop: "auto", marginBottom: 16 }}>
                                        <Typography.Text style={{ color: "var(--color-primary)", fontWeight: 500, textDecoration: "underline", fontSize: 16 }}>
                                            Ver impacto por etapa
                                        </Typography.Text>
                                    </div>
                                </Card>
                            </Link>
                        </Col>
                    ))}
                </Row>
            )}
        </>
    )
}
